import {useMemo} from 'react';
import {TranslatableEntry} from 'features/Translations/TranslatableResource/types';

const isFileGid = (value: string): boolean =>
  value.startsWith('gid://shopify/MediaImage/') ||
  value.startsWith('gid://shopify/Video/') ||
  value.startsWith('gid://shopify/GenericFile/');

const isShopImage = (value: string): boolean =>
  value.startsWith('shopify://shop_images/');
const isVideo = (value: string): boolean =>
  value.startsWith('shopify://files/videos/');

export const useExtractPreviewsData = (
  translatableEntries: TranslatableEntry[],
) => {
  const {possiblyDuplicatedResourceIds, possiblyDuplicatedFilenames} = useMemo(
    () =>
      translatableEntries.reduce<{
        possiblyDuplicatedResourceIds: string[];
        possiblyDuplicatedFilenames: string[];
      }>(
        (acc, {defaultContent, translatedContent, translatedMarketContent}) => {
          [
            defaultContent.value,
            translatedContent?.value,
            translatedMarketContent?.value,
          ]
            .filter(Boolean)
            .forEach(
              (value) =>
                (value &&
                  isFileGid(value) &&
                  acc.possiblyDuplicatedResourceIds.push(value)) ||
                (value &&
                  (isShopImage(value) || isVideo(value)) &&
                  acc.possiblyDuplicatedFilenames.push(value)),
            );

          return acc;
        },
        {
          possiblyDuplicatedResourceIds: [],
          possiblyDuplicatedFilenames: [],
        },
      ),
    [translatableEntries],
  );

  return useMemo(
    () => ({
      resourceIds: [...new Set(possiblyDuplicatedResourceIds)],
      filenames: [...new Set(possiblyDuplicatedFilenames)],
    }),
    [possiblyDuplicatedResourceIds, possiblyDuplicatedFilenames],
  );
};
